import { render, staticRenderFns } from "./BookStatusTag.vue?vue&type=template&id=2ec87ba4"
import script from "./BookStatusTag.vue?vue&type=script&lang=js"
export * from "./BookStatusTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports